import { useEffect, useState } from "react";
import { RefreshCw } from "lucide-react";

import { Button } from "@/components/ui/button";

/** Bundle que trae el index.html (assets/index-<hash>.js), o null. */
export function bundleDe(html: string): string | null {
  const m = html.match(/assets\/index-[A-Za-z0-9_-]+\.js/);
  return m ? m[0] : null;
}

/** El bundle con el que arrancó esta pestaña. */
function bundleActual(): string | null {
  const s = document.querySelector<HTMLScriptElement>('script[type="module"][src*="/assets/index-"]');
  return s ? bundleDe(s.src) : null;
}

const CADA_MS = 5 * 60 * 1000;

/**
 * Avisa cuando hay un despliegue nuevo de la interfaz.
 *
 * El index.html ya se sirve con `no-store`, pero una pestaña que lleva horas
 * abierta sigue corriendo el JS con el que cargó: tras un despliegue no ve lo
 * nuevo (el 2-nov la tarjeta "Descargar" no salía hasta recargar). Cada 5 min
 * se compara el bundle del index.html del servidor con el de la pestaña.
 */
export function VersionNuevaBanner() {
  const [nueva, setNueva] = useState(false);

  useEffect(() => {
    const actual = bundleActual();
    if (!actual) return;
    let vivo = true;
    const revisar = async () => {
      try {
        const r = await fetch("/index.html", { cache: "no-store" });
        if (!r.ok) return;
        const servidor = bundleDe(await r.text());
        if (vivo && servidor && servidor !== actual) setNueva(true);
      } catch {
        // Sin red no hay nada que avisar.
      }
    };
    const id = window.setInterval(() => void revisar(), CADA_MS);
    return () => {
      vivo = false;
      window.clearInterval(id);
    };
  }, []);

  if (!nueva) return null;
  return (
    <div
      role="status"
      className="mb-4 flex items-center justify-between gap-3 rounded-md border border-sky-300 bg-sky-50 px-4 py-2 text-sm text-sky-900"
    >
      <span>Hay una versión nueva de AROC.</span>
      <Button size="sm" variant="outline" onClick={() => window.location.reload()}>
        <RefreshCw className="mr-1 size-4" aria-hidden />
        Recargar
      </Button>
    </div>
  );
}
